import { MEMBERSHIP_ROLE_LABEL } from "@/constants/uiLabels";

export const ORG_MEMBERSHIP_ROLES = [
  "caregiver",
  "medicus",
  "board",
  "organizer",
  "admin",
] as const;

export type OrgMembershipRole = (typeof ORG_MEMBERSHIP_ROLES)[number];

export const ORG_ROLE_LABELS = MEMBERSHIP_ROLE_LABEL;

export function isOrgMembershipRole(value: string): value is OrgMembershipRole {
  return (ORG_MEMBERSHIP_ROLES as readonly string[]).includes(value);
}

export function formatOrgRoles(roles: readonly string[]): string {
  return roles
    .filter(isOrgMembershipRole)
    .map((role) => ORG_ROLE_LABELS[role])
    .join(", ");
}
